var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBell = function SvgBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 26.2317C17.155 26.2317 18.0994 25.2873 18.0994 24.133H13.9018C13.9018 25.2873 14.8358 26.2317 16.0006 26.2317ZM22.297 19.9354V14.6884C22.297 11.4668 20.576 8.76982 17.5747 8.05623V7.34265C17.5747 6.47165 16.8716 5.76855 16.0006 5.76855C15.1296 5.76855 14.4265 6.47165 14.4265 7.34265V8.05623C11.4148 8.76982 9.70426 11.4563 9.70426 14.6884V19.9354L7.60547 22.0342V23.0836H24.3958V22.0342L22.297 19.9354Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell.4b8d69f6b2defeb5271be264bb339cb7.svg";